module.exports = __webpack_public_path__ + "static/media/phenotypeCategory.eeeff691.svg";